/**
 * Task WA-center: WhatsApp 中心 (sidebar → WhatsApp) — connection, confirmation / reminder texts, synced contacts,
 * broadcasts (群发) and activity. One row per key: [key, English, 中文]; Malay falls back to English.
 */
const ROWS = [
  ["wac.nav","WhatsApp","WhatsApp"],
  ["wac.title","WhatsApp","WhatsApp"],
  ["wac.sub","Your shop's own WhatsApp: link it, edit the booking texts, sync contacts and send broadcasts.","店铺自己的 WhatsApp：连接、编辑预约消息、同步联系人和群发。"],
  ["wac.refresh","Refresh","刷新"],
  ["wac.tab.connect","Connect","连接"],
  ["wac.tab.confirm","Confirmation text","预约确认模板"],
  ["wac.tab.reminder","Reminder text","预约提醒模板"],
  ["wac.tab.contacts","Contacts","联系人"],
  ["wac.tab.broadcast","Broadcast","群发"],
  ["wac.tab.activity","Activity","动态"],
  ["wac.head.contacts","Contacts {n}","联系人 {n}"],
  ["wac.head.synced","Synced {date}","同步 {date}"],
  ["wac.head.never","Not synced yet","尚未同步"],
  ["wac.off","WhatsApp via a linked phone is switched off on this platform.","平台已关闭 WhatsApp 关联设备功能。"],
  ["wac.needConnect","Connect your WhatsApp first (tab Connect).","请先连接 WhatsApp（「连接」页）。"],
  ["wac.goConnect","Go to Connect","去连接"],
  ["wac.movedFrom","These settings used to be under Settings → Customer messages.","这些设置原在 设置 → 顾客消息。"],
  ["wac.moved","WhatsApp settings moved to the sidebar: WhatsApp","WhatsApp 设置已移至左侧「WhatsApp」"],
  ["wac.movedOpen","Open WhatsApp","打开 WhatsApp"],
  // templates
  ["wac.tpl.introConfirm","Sent from your linked WhatsApp right after a booking is made (POS or online).","预约创建后立即从已连接的 WhatsApp 发送（收银台或在线预约）。"],
  ["wac.tpl.introReminder","Sent from your linked WhatsApp before the appointment, at the lead times below.","在预约前按下面设置的时间，从已连接的 WhatsApp 发送。"],
  ["wac.tpl.lang","Language","语言"],
  ["wac.tpl.langHint","Customers get the text in their own language (English if not set).","顾客收到自己语言的版本（未设置则为英文）。"],
  ["wac.tpl.text","Message text","消息内容"],
  ["wac.tpl.chips","Tap to insert","点击插入"],
  ["wac.tpl.ph.customer","Customer","顾客"],
  ["wac.tpl.ph.service","Service","服务"],
  ["wac.tpl.ph.date","Date","日期"],
  ["wac.tpl.ph.time","Time","时间"],
  ["wac.tpl.ph.staff","Staff","服务人员"],
  ["wac.tpl.ph.shop","Shop","店名"],
  ["wac.tpl.ph.address","Address","地址"],
  ["wac.tpl.ph.link","Manage link","管理链接"],
  ["wac.tpl.preview","Preview (example customer)","预览（示例顾客）"],
  ["wac.tpl.previewNote","A greeting / sign-off varies slightly per message so it reads naturally; staff and address are added when the text doesn't include them.","每条消息的问候语和结尾会略有不同，读起来更自然；文本中没有服务人员和地址时会自动附上。"],
  ["wac.tpl.save","Save","保存"],
  ["wac.tpl.saved","Saved","已保存"],
  ["wac.tpl.reset","Restore default","恢复默认"],
  ["wac.tpl.resetDone","Back to the default text","已恢复默认文本"],
  ["wac.tpl.custom","Your own text","自定义文本"],
  ["wac.tpl.default","Default (same as the e-mail text)","默认（与邮件文本相同）"],
  ["wac.tpl.test","Send test to my WhatsApp","发送测试到我的 WhatsApp"],
  ["wac.tpl.testSent","Test queued to {phone} (your own chat). It arrives within a minute between 08:00 and 22:00.","测试已排队发送到 {phone}（您自己的对话）。08:00–22:00 期间约一分钟内送达。"],
  ["wac.tpl.unknown","Unknown placeholder: {ph}","未知占位符：{ph}"],
  ["wac.tpl.hours","Reminder (hours before)","提醒（提前小时数）"],
  ["wac.tpl.hoursHint","Comma-separated, e.g. 24, 2 — the same setting as Settings → Customer messages → Reminders & rules.","用逗号分隔，例如 24, 2 —— 与 设置 → 顾客消息 → 提醒与规则 是同一个设置。"],
  ["wac.tpl.hoursSaved","Reminder times saved","提醒时间已保存"],
  // contacts
  ["wac.ct.intro","All WhatsApp contacts of the linked number (names and numbers only — chats are never read or stored).","已连接号码的全部 WhatsApp 联系人（只有名字和号码，不读取也不保存聊天内容）。"],
  ["wac.ct.count","{n} contacts · {m} are customers","{n} 个联系人 · {m} 个是顾客"],
  ["wac.ct.sync","Refresh sync","刷新同步"],
  ["wac.ct.syncAsked","Sync requested — new contacts appear in a minute or two.","已请求同步，一两分钟内显示新联系人。"],
  ["wac.ct.search","Search name or number","搜索名字或号码"],
  ["wac.ct.f.all","All contacts","全部联系人"],
  ["wac.ct.f.customers","Customers only","仅顾客"],
  ["wac.ct.f.others","Not customers","非顾客"],
  ["wac.ct.customer","Customer","顾客"],
  ["wac.ct.optedOut","Opted out","已退订"],
  ["wac.ct.empty","No contacts yet. Connect WhatsApp — contacts sync automatically after linking.","还没有联系人。连接 WhatsApp 后会自动同步联系人。"],
  ["wac.ct.noName","(no name)","（无名字）"],
  ["wac.ct.more","Showing the first {n}. Search to find others.","仅显示前 {n} 个，请搜索查找其他联系人。"],
  // broadcast
  ["wac.bc.step1","1. Write message","1. 编写消息"],
  ["wac.bc.step2","2. Choose contacts","2. 选择联系人"],
  ["wac.bc.placeholder","Message to send (WhatsApp formatting: *bold* _italic_). {name} = the contact's name.","输入要群发的内容（支持 WhatsApp 格式：*粗体* _斜体_）。{name} = 联系人名字。"],
  ["wac.bc.insertName","Insert {name}","插入 {name}"],
  ["wac.bc.image","Add a picture","加一张图片"],
  ["wac.bc.imageRemove","Remove picture","移除图片"],
  ["wac.bc.imageHint","One JPG / PNG picture, sent with the text as caption (max 800 KB; large photos are shrunk).","一张 JPG / PNG 图片，文字作为图片说明一起发送（最大 800 KB，大图会自动缩小）。"],
  ["wac.bc.imageBad","This picture can't be used (JPG / PNG / WebP, max 800 KB).","无法使用这张图片（JPG / PNG / WebP，最大 800 KB）。"],
  ["wac.bc.saveTpl","Save as template","保存为模板"],
  ["wac.bc.tplName","Template name","模板名称"],
  ["wac.bc.tplSaved","Template saved","模板已保存"],
  ["wac.bc.pickTpl","Use a saved template…","使用已保存的模板…"],
  ["wac.bc.delTpl","Delete template","删除模板"],
  ["wac.bc.gap","Random gap between each contact","每个联系人之间随机间隔"],
  ["wac.bc.gapUnit","seconds (min 20)","秒（最少 20 秒）"],
  ["wac.bc.risk","Personal numbers that send many identical messages fast can be restricted or banned by WhatsApp. Keep the gap long (default 20–60 s), send only to people who know your shop, and keep the daily total low.","个人号码短时间大量发送相同消息可能被 WhatsApp 限制或封号。请保持较长间隔（默认 20–60 秒），只发给认识您店铺的人，并控制每日数量。"],
  ["wac.bc.rules","Sent only 08:00–22:00 shop time, at most {cap} WhatsApp messages a day (booking confirmations and reminders included). What doesn't fit continues the next day from 08:00.","仅在店铺时间 08:00–22:00 发送，每天最多 {cap} 条 WhatsApp 消息（含预约确认和提醒）。超出的部分次日 08:00 起继续发送。"],
  ["wac.bc.aud.all","All synced contacts","全部已同步联系人"],
  ["wac.bc.aud.customers","Only customers","仅顾客"],
  ["wac.bc.excludeOptOut","Exclude customers who opted out","排除已退订的顾客"],
  ["wac.bc.selectAll","Select all","全选"],
  ["wac.bc.selectNone","Select none","全不选"],
  ["wac.bc.selected","{n} selected","已选 {n} 人"],
  ["wac.bc.review","Preview & send","预览并发送"],
  ["wac.bc.confirmTitle","Send this broadcast?","确认群发？"],
  ["wac.bc.confirmBody","Will send to {n} people, about {min} minutes in total.","将发送给 {n} 人，预计约 {min} 分钟。"],
  ["wac.bc.confirmDays","Over the daily limit ({cap}): it is spread over {d} days —","超过每日上限（{cap} 条）：将分 {d} 天发送 ——"],
  ["wac.bc.dayLine","{date}: {n}","{date}：{n} 条"],
  ["wac.bc.startsAt","First message: {date}","第一条发送时间：{date}"],
  ["wac.bc.send","Send","确认发送"],
  ["wac.bc.started","Broadcast started — follow it under Activity.","群发已开始，可在「动态」查看进度。"],
  ["wac.bc.needText","Write the message first.","请先输入消息内容。"],
  ["wac.bc.needContacts","Choose at least one contact.","请至少选择一个联系人。"],
  // activity
  ["wac.ac.broadcasts","Broadcasts","群发任务"],
  ["wac.ac.noBroadcasts","No broadcasts yet.","还没有群发。"],
  ["wac.ac.progress","Sent {sent} · Failed {failed} · Waiting {pending} / {total}","已发 {sent} · 失败 {failed} · 待发 {pending} / {total}"],
  ["wac.ac.next","Next: {date}","下一条：{date}"],
  ["wac.ac.pause","Pause","暂停"],
  ["wac.ac.resume","Resume","继续"],
  ["wac.ac.cancel","Cancel","取消"],
  ["wac.ac.cancelConfirm","Cancel this broadcast? Messages not sent yet won't be sent.","取消这个群发？尚未发送的消息将不再发送。"],
  ["wac.ac.st.running","Sending","发送中"],
  ["wac.ac.st.paused","Paused","已暂停"],
  ["wac.ac.st.canceled","Cancelled","已取消"],
  ["wac.ac.st.done","Finished","已完成"],
  ["wac.ac.log","Message log","发送记录"],
  ["wac.ac.t.all","All types","全部类型"],
  ["wac.ac.t.confirm","Confirmation","确认"],
  ["wac.ac.t.reminder","Reminder","提醒"],
  ["wac.ac.t.broadcast","Broadcast","群发"],
  ["wac.ac.t.test","Test","测试"],
  ["wac.ac.s.all","All statuses","全部状态"],
  ["wac.ac.s.sent","Sent","已发送"],
  ["wac.ac.s.pending","Waiting","等待中"],
  ["wac.ac.s.failed","Failed","失败"],
  ["wac.ac.s.skipped","Not sent","未发送"],
  ["wac.ac.empty","No WhatsApp messages yet.","还没有 WhatsApp 消息。"],
  ["wac.ac.full","All customer messages (incl. e-mail)","全部顾客消息（含邮件）"],
  ["wac.ac.err.canceled","cancelled","已取消"],
  ["wac.ac.err.no_whatsapp","number has no WhatsApp","该号码没有 WhatsApp"],
  ["wac.ac.err.daily_cap","daily limit reached","已达每日上限"],
] as const;

export type WacKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<WacKey, string>;

export const taskWAC = { en: col(1), zh: col(2), ms: col(1) };
